var service = function(moneyFilter, C) {
  // skuString returns a full inventory SKU representation
  var skuString = function(inventory) {
    var str = 'N/A';

    if (inventory.sku) {
      str = inventory.sku;
    } else {
      var items = []
      if (inventory.unit_sku) {
        items.push(`${inventory.unit_sku} (unit)`);
      }
      if (inventory.case_sku) {
        items.push(`${inventory.case_sku} (case)`);
      }
      str = items.join(" <br/> ");
    }

    return str.trim();
  }

  var priceString = function(inventory) {
    var str = '';

    var casePrice = inventory.case_price ? moneyFilter(inventory.case_price) + 'c' : '';
    var unitPrice = inventory.unit_price ? moneyFilter(inventory.unit_price) + 'u' : '';

    if (unitPrice) str = unitPrice;
    if (casePrice) {
      if (str.trim()) {
        str += " / " + casePrice;
      } else {
        str = casePrice;
      }
    }

    return str.trim();
  };

  var quantityString = function(inventory) {
    var str = '';

    var unitQuantity = inventory.unit_quantity ? inventory.unit_quantity + 'u' : '';
    var caseQuantity = inventory.case_quantity ? inventory.case_quantity + 'c' : '';

    if (unitQuantity) str = unitQuantity;
    if (caseQuantity) {
      if (str.trim()) {
        str += " / " + caseQuantity;
      } else {
        str = caseQuantity;
      }
    }

    return str;
  };

  var soldByString = function(inventory) {
    var translations = {
      'cases_only': 'Cases Only',
      'units_only': 'Units Only',
      'cases_and_units': 'Cases And Units'
    };

    if (inventory.distributor && !inventory.distributor.uses_multiple_skus) {
      return 'N/A';
    } else {
      return translations[inventory.sold_by] || '';
    };
  };

  return {
    skuString:      skuString,
    priceString:    priceString,
    quantityString: quantityString,
    soldByString:   soldByString
  };
};

service.$inject = ['moneyFilter', 'C'];

tiz.service('Inventory', service);
